import { Order, StateForm } from './types'

type RecordsAction =
  | { type: 'initializer'; payload: { [orderNumber: string]: Order } }
  | { type: 'saveRecord'; payload: Order }
  | { type: 'deleteRecords'; payload: string[] }
  | { type: 'changeStates'; payload: { id: string; stateForm: StateForm }[] }

export const recordsReducer = (
  state: { [orderNumber: string]: Order },
  action: RecordsAction,
): { [orderNumber: string]: Order } => {
  switch (action.type) {
    case 'initializer':
      return { ...state, ...action.payload }

    case 'saveRecord':
      return {
        ...state,
        [action.payload.orderNumber!]: action.payload,
      }

    case 'deleteRecords':
      return Object.fromEntries(
        Object.values(state)
          .filter((item) => !action.payload.includes(item.orderNumber!))
          .map((item) => [[item.orderNumber], item]),
      )

    case 'changeStates':
      return Object.fromEntries(
        Object.values(state).map((item) => {
          const change = action.payload.find((p) => p.id === item.orderNumber)
          return [[item.orderNumber], change ? { ...item, stateForm: change.stateForm } : item]
        }),
      )

    default:
      return state
  }
}
